// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  NewQuotePolicy,
  type QuotePolicy,
  type QuotePolicyWireFormat,
} from '../QuotePolicy/QuotePolicy';

export class CheckQuotePoliciesResults {
  readonly violatedPolicies: QuotePolicy[];

  constructor(data: { [key: string]: any } = {}) {
    this.violatedPolicies = (data.violatedPolicies ?? []).map((violatedPolicies: any) =>
      NewQuotePolicy(violatedPolicies),
    );
  }

  static zero(): CheckQuotePoliciesResults {
    const zeroValues: ExcludeMethodsDeep<CheckQuotePoliciesResults> = {
      violatedPolicies: [],
    };
    return new CheckQuotePoliciesResults(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CheckQuotePoliciesResultsWireFormat = {
  violatedPolicies: QuotePolicyWireFormat[];
};

type NewCheckQuotePoliciesResultsProps = PartialDeep<
  CheckQuotePoliciesResults,
  { recurseIntoArrays: true }
>;
export const NewCheckQuotePoliciesResults: (
  props: NewCheckQuotePoliciesResultsProps,
) => CheckQuotePoliciesResults = (props) => new CheckQuotePoliciesResults(props);

type NewCheckQuotePoliciesResultsFromWireFormatProps = PartialDeep<
  CheckQuotePoliciesResultsWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCheckQuotePoliciesResultsFromWireFormat: (
  props: NewCheckQuotePoliciesResultsFromWireFormatProps,
) => CheckQuotePoliciesResults = (props) => new CheckQuotePoliciesResults(props);
